export default __webpack_public_path__ + "static/media/1040.d117bf43.png";